<template>
    <v-container fluid class="pt-3">
      <OrderReportTable :shop="shop" :showStat="true"></OrderReportTable>
    </v-container>
  </template>
  <script>
  import OrderReportTable from "@/components/table/OrderReportTable";
  
  export default {
    components: {
        OrderReportTable,
    },
    data() {
      return {
        shop: null,
      };
    },
    created() {},
  };
  </script>
  